const TYPE = `[GLOBAL]`;

const GLOBAL_TYPES = {
    DATE_DID_CHANGE: `${TYPE} DATE_DID_CHANGE`,
}

export default GLOBAL_TYPES;